import store from '../../store';
import triggerEvent from './biEditorLogger';
import biData from '../../bi/editorEvents.json';
import { getUserDataFromDB } from '../api/dataApi';

const urlWindow = new URL(window.location.href);
const dataPublicCache = Object.create(null);
let _applicationLoaded = false;
let userDataObj = {};

// const HELP = {
//   ADI_KEY: 'OB_ON_HELP',
//   BASE_URL:
//     'https://wix.wixanswers.com/app/kb/article/0f7748f1-8893-4696-85e7-815e690b98a0/en',
//   SETTINGS_ARTICLE_ID: '0f7748f1-8893-4696-85e7-815e690b98a0',
// };

// window.Wix.PubSub.publish(HELP.ADI_KEY, {
//   url: `${HELP.BASE_URL}`,
// });

// const openHelpArticle = (articleId = HELP.SETTINGS_ARTICLE_ID) => {
//   window.Wix.PubSub.publish(
//       HELP.ADI_KEY,
//       {url: `${HELP.BASE_URL}/${articleId}`});
// }

// const onHelp = () => {
//   WixService.openHelpArticle(settingsArticleId);
// }

/**
 * Return object that need to save on data public
 * @param {Object} userData
 */
const _defaultDataPublicData = (userData) => {
  return {
    in_access_token: userData.in_access_token ? userData.in_access_token : '',
    in_u_id: userData.in_u_id ? userData.in_u_id : '',
    expires_in: userData.expires_in ? userData.expires_in : null,
    in_u_name: userData.in_u_name ? userData.in_u_name : '',
    template_in_u_id: userData.template_in_u_id
      ? userData.template_in_u_id
      : null,
    template_site_owner_id: userData.template_site_owner_id
      ? userData.template_site_owner_id
      : null,
    template_removed_auth: userData.template_removed_auth
      ? userData.template_removed_auth
      : false,
    seed: userData.seed ? userData.seed : Math.floor(Math.random() * 100 + 1),
    algor: userData.algor ? userData.algor : [],
    error_login: userData.error_login ? userData.error_login : false,
    desktop_layout_full_width: userData.desktop_layout_full_width
      ? userData.desktop_layout_full_width
      : undefined,
    onceConnected: userData.onceConnected ? userData.onceConnected : false,
  };
};

function _postData(urlPath, value = {}) {
  fetch(urlPath, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-wix-comp-id': getCompId(),
      'x-wix-instance-id': urlWindow.searchParams.get('instance'),
      'x-wix-locale': 'en',
      'x-instagram-token': null,
    },
    body: JSON.stringify(value),
  });
}

function _getDataPublic(key) {
  return new Promise((resolve, reject) => {
    window.Wix.Data.Public.get(
      key,
      {
        scope: 'COMPONENT',
      },
      (d) => {
        Object.assign(dataPublicCache, d);
        resolve(d);
      },
      (f) => {
        reject(f);
      },
    );
  });
}

const getCurrentMode = () => {
  return window.Wix.Utils.getViewMode();
};

const getDeviceType = () => {
  return window.Wix.Utils.getDeviceType();
};

const getCompId = () => {
  return window.Wix.Utils.getOrigCompId() || window.Wix.Utils.getCompId();
};

const getInstanceId = () => {
  return window.Wix.Utils.getInstanceId();
};

const getInstanceValue = (val) => {
  return window.Wix.Utils.getInstanceValue(val);
};

const deleteDataPublic = (key) => {
  cleanDataPublicChatch(key);
  window.Wix.Data.Public.remove(
    key,
    { scope: 'COMPONENT' },
    function (d) {
      console.log('Data Public deleted!');
    },
    function (f) {
      console.log('Fail to delete Data Public error - ', f);
    },
  );
};

const getViewMode = () => {
  return window.Wix.Utils.getViewMode();
};

const isExpired = (time) => {
  return new Date() >= new Date(Number(time));
};

const getDataPublicObj = (userData) => {
  return {
    in_access_token: userData.in_access_token ? userData.in_access_token : '',
    in_u_id: userData.in_u_id ? userData.in_u_id : '',
    expires_in: userData.expires_in ? userData.expires_in : null,
    in_u_name: userData.in_u_name ? userData.in_u_name : '',
    template_in_u_id: userData.template_in_u_id
      ? userData.template_in_u_id
      : null,
    template_site_owner_id: userData.template_site_owner_id
      ? userData.template_site_owner_id
      : null,
    template_removed_auth: userData.template_removed_auth
      ? userData.template_removed_auth
      : false,
    error_login: userData.error_login ? userData.error_login : false,
    desktop_layout_full_width: userData.desktop_layout_full_width
      ? userData.desktop_layout_full_width
      : undefined,
    onceConnected: userData.onceConnected ? userData.onceConnected : false,
  };
};

const fixDataPublic = (d, key) => {
  if (
    d &&
    d[key] &&
    d[key].in_access_token &&
    userDataObj &&
    userDataObj.insta_access_token
  ) {
    const newDataPublic = {};
    newDataPublic.in_access_token = userDataObj.insta_access_token;
    newDataPublic.in_u_id = userDataObj.insta_user_id;
    newDataPublic.isBusinessApp = userDataObj.isBusinessApp;
    newDataPublic.hashtags = userDataObj.hashtags || [];
    newDataPublic.loadMoreBtnText = userDataObj.loadMoreBtnText;
    newDataPublic.followBtnText = userDataObj.followBtnText;
    newDataPublic.hashtagTitleText = userDataObj.hashtagTitleText;

    if (userDataObj.expires_in) {
      newDataPublic.expires_in = userDataObj.expires_in;
    }
    if (userDataObj.errorTokenType) {
      newDataPublic.errorTokenType = userDataObj.errorTokenType;
    }
    d[key] = { ...d[key], ...newDataPublic };
    if (getViewMode() === 'editor') {
      const dpToSave = getDataPublicObj(d[key]);
      setDataPublic(key, dpToSave);
    }
  }
  Object.assign(dataPublicCache, d);
  return d;
};

function setDataPublic(key, value) {
  if (value && value.errorTokenType) {
    delete value.errorTokenType;
  }

  window.Wix.Data.Public.set(key, value, {
    scope: 'COMPONENT',
  });
}

const getDataPublicWithUpdatedAccessToken = (key) => {
  return new Promise((resolve, reject) => {
    _getDataPublic(key)
      .then((d) => {
        const dp = d && d[key];
        const isConnected = dp && dp.in_access_token;
        const isTokenMaybeInvalid =
          isConnected &&
          (!dp.expires_in || (dp.expires_in && isExpired(dp.expires_in)));
        if (isTokenMaybeInvalid) {
          if (!userDataObj.insta_access_token) {
            getUserDataFromDB()
              .then((userData) => {
                userDataObj = userData ? userData : {};
                console.log('userData from DB', userData);
                d = fixDataPublic(d, key);
                console.log('data public After merge with DB', d);
                resolve(d);
              })
              .catch((err) => {
                console.log('Fail to get Data from DB', err);
                Object.assign(dataPublicCache, d);
                resolve(d);
              });
          } else {
            d = fixDataPublic(d, key);
            resolve(d);
          }
        } else {
          console.log('data public', d);
          Object.assign(dataPublicCache, d);
          resolve(d);
        }
      })
      .catch((f) => {
        console.log('No exist DP');
        getUserDataFromDB()
          .then((userData) => {
            resolve(userData);
          })
          .catch((err) => reject(err));
      });
  });
};

/**
 * Get public data from wix storage
 * @param key
 * @returns {Promise}
 */
const getDataPublic = (key) => {
  return new Promise((resolve, reject) => {
    if (dataPublicCache[key] !== undefined) {
      const result = { [key]: dataPublicCache[key] };
      resolve(result);
    }

    getDataPublicWithUpdatedAccessToken(key)
      .then((d) => resolve(d))
      .catch((f) => reject(f));
  });
};

/**
 * Allows a component app to report that it has been loaded.
 * @return {*}
 */
const applicationLoaded = () => {
  if (!_applicationLoaded) {
    _applicationLoaded = true;
    return window.Wix.Performance.applicationLoaded();
  }
};

/**
 * Allows a component app to report on a loading step.
 * @param {Number} stageNumber
 * @param [stageDescription]
 */
const applicationLoadingStep = (stageNumber, stageDescription) => {
  stageDescription = stageDescription || '';
  window.Wix.Performance.applicationLoadingStep(stageNumber, stageDescription);
};

const isEditorX = () => {
  // return true;
  const { responsive } = store.getState().settingsReducer;
  return responsive || false;
};

window.Wix.addEventListener(window.Wix.Events.SITE_SAVED, () => {
  triggerEvent(biData.SITE_SAVED);
});

window.Wix.addEventListener(window.Wix.Events.PUBLIC_DATA_CHANGED, (data) => {
  const settingsKeyName1 = Object.keys(data).find(function (key) {
    return key.startsWith('settingscomp');
  });

  const settingsKeyName2 = Object.keys(dataPublicCache).find(function (key) {
    return key.startsWith('settingscomp');
  });

  if (settingsKeyName1 && settingsKeyName2) {
    delete dataPublicCache[settingsKeyName2];
  }

  Object.assign(dataPublicCache, data);
});

const getOrigInstaceId = () => {
  const instanceStr = urlWindow.searchParams.get('instance');
  const instanceObj = JSON.parse(atob(instanceStr.split('.')[1]));
  return instanceObj.originInstanceId;
};

const cleanDataPublicChatch = (key) => {
  delete dataPublicCache[key];
};

const getBaseUrl = () => {
  return new Promise((res, rej) => {
    window.Wix.getSiteInfo((data) => {
      if (!data) return rej(data);
      res(data.baseUrl);
    });
  });
};

export default {
  getOrigInstaceId,
  cleanDataPublicChatch,
  isEditorX,
  applicationLoadingStep,
  applicationLoaded,
  getDataPublic,
  deleteDataPublic,
  getViewMode,
  getInstanceValue,
  getInstanceId,
  getCompId,
  getDeviceType,
  getCurrentMode,
  getBaseUrl,
};
